"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchQuestions = fetchQuestions;
var _common = require("./common");
function fetchQuestions(url, token, peerId, itemId, categoryId, senderType) {
  var params = ["ad_id=".concat(itemId), "peer_id=".concat(peerId), "sender_type=".concat(senderType), "category_id=".concat(categoryId)].join('&');
  var urlWithParams = "".concat(url, "?").concat(params);
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token,
      'x-accept-version': 1,
      'cache-control': 'no-cache'
    },
    credentials: 'include'
  };
  return (0, _common.request)(urlWithParams, options).then(function (res) {
    if (res) {
      return res;
    }
    throw new Error();
  });
}